import React, { useMemo } from 'react';
import { useCollaboratorInvoices } from '../../../../../../hooks/api/useCollaboratorInvoices';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { ContentStack } from '../../../../../v2BaseComponents/Stack';
import InvoiceCard from '../../../../../shared/InvoiceCard';
import MaxWidthRestrictedContent from '../../../../../v2BaseComponents/MaxWidthRestrictedContent';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import { useProfilesTabNavigation } from '../../../../../../utils/appNavigationNames';

export type CollaboratorInvoicesTabOwnProps = {
    medicalProfileId: string;
    collaboratorId: string;
};

export type CollaboratorInvoicesTabProps = CollaboratorInvoicesTabOwnProps;

const CollaboratorInvoicesTab: React.FC<CollaboratorInvoicesTabProps> = ({ medicalProfileId, collaboratorId }) => {
    const { isLoadingInvoices, invoices } = useCollaboratorInvoices({
        medicalProfileId,
        collaboratorId,
        isOrganizationCollaborator: true,
    });

    const { navigate } = useProfilesTabNavigation();

    const sortedInvoices = useMemo(
        () =>
            (invoices || []).sort(
                (a, _b) => new Date(a.createdDateTime).getTime() - new Date(a.createdDateTime).getTime(),
            ),
        [invoices],
    );

    return (
        <AnimateLoadedContent isLoading={isLoadingInvoices}>
            {() => (
                <MainContentContainer>
                    <MaxWidthRestrictedContent variant="sm">
                        <ContentStack>
                            {sortedInvoices.map((invoice) => (
                                <InvoiceCard
                                    key={invoice.invoiceId}
                                    invoice={invoice}
                                    onPress={() => {
                                        navigate('collaborator-invoice', {
                                            profileId: medicalProfileId,
                                            collaboratorId,
                                            invoiceId: invoice.invoiceId,
                                        });
                                    }}
                                />
                            ))}
                        </ContentStack>
                    </MaxWidthRestrictedContent>
                </MainContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(CollaboratorInvoicesTab);
